import { render, staticRenderFns } from "./storeList.vue?vue&type=template&id=72b1dba9"
import script from "./storeList.vue?vue&type=script&lang=js"
export * from "./storeList.vue?vue&type=script&lang=js"
import style0 from "./storeList.vue?vue&type=style&index=0&id=72b1dba9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports